<script setup lang="ts">
import logo from '@/assets/logo.svg'
import BackdropBg from '@/components/shared/main/BackdropBg.vue'
import { Button } from '@/components/ui/button'
import { Head } from '@inertiajs/vue3'
import { ExternalLink } from 'lucide-vue-next'
</script>

<template>
    <Head title="Em breve | Fórum ILOS" />
    <main class="relative flex min-h-dvh flex-col items-center justify-center gap-4 overflow-hidden bg-[#444] bg-gradient-to-b text-white">
        <div class="relative z-20 container flex flex-col items-center justify-center gap-6 text-center">
            <a href="https://forumilos.com.br/" target="_blank">
                <img :src="logo" alt="" class="size-24" />
            </a>
            <h1 class="relative z-20 max-w-xl text-center text-4xl font-semibold uppercase lg:text-6xl">Nosso site está em construção!</h1>
            <div class="font-inter w-full max-w-3xl space-y-4 text-balance">
                <p>
                    Estamos trabalhando para trazer uma experiência incrível para você. Em breve, nosso site estará no ar, cheio de novidades e
                    conteúdos exclusivos! Enquanto isso, aproveite para nos seguir nas redes sociais ou entre em contato conosco por meio de outros
                    canais.
                </p>
                <p><strong>Agradecemos pela paciência e compreensão. Fique de olho, logo estaremos no ar! </strong></p>
            </div>
            <Button as="a" href="https://forumilos.com.br/">Fórum ILOS <ExternalLink /></Button>
        </div>

        <BackdropBg />
        <div class="pointer-events-none absolute inset-0 z-0 min-h-full w-full bg-[#040404]/80 backdrop-blur-[250px]"></div>
    </main>
</template>
